<template>
  <div class="">
    <Post :key="pp._id" :post="pp" v-for="pp in getList()"></Post>
    <div class="text-center mt-5" v-if="getList().length > 0">
      <div  @click="loadMore()" class="inline-block px-6 py-3 border-gray-500 border rounded-lg hover:bg-gray-400 cursor-pointer">
        <span v-if="!PostState.loading.feed">Load More</span>
        <span v-if="PostState.loading.feed" class="text-green-700">Refreshing...</span>
      </div>
      <div class="h-16"></div>
    </div>
  </div>
</template>

<script>
import { state as AppState, Posts } from '../../api/api'

export default {
  components: {
    // LoaderUI: require('./LoaderUI.vue').default,
    Post: require('../uis-post/Post.vue').default
  },
  data () {
    return {
      loading: false,
      AppState,
      PostState: Posts.state
    }
  },
  watch: {
    PostState: {
      deep: true,
      handler () {
        this.$forceUpdate()
      }
    },
    'AppState.me': {
      deep: true,
      async handler () {
        await Posts.initFeed({ userID: AppState.me.user._id })
      }
    }
  },
  async mounted () {
    await Posts.initFeed({ userID: AppState.me.user._id })
  },
  methods: {
    getList () {
      return Posts.getCahceOf({ userID: AppState.me.user._id })
    },
    async loadMore () {
      await Posts.loadMore({ userID: AppState.me.user._id })
      this.$forceUpdate()
    }
  }
}
</script>

<style>

</style>
